import React from 'react';
import CheckBoxInput from "../CheckBoxInput";

type BoundCheckBoxInputProps<T> = {
  name: string;
  value?: boolean | undefined;
  label: string;
  disabled?: boolean;
  required?: boolean;
  icon?: React.ReactNode;
  checkedIcon?: React.ReactNode;
  onChange: (newQuery: T) => void;
}

const BoundCheckBoxInput = <T,>({
  name,
  value = false,
  label,
  disabled = false,
  required = false,
  icon = undefined,
  checkedIcon = undefined,
  onChange
}: BoundCheckBoxInputProps<T>) => {

  //Possible improvement: debounce the onChange event to limit frequency of updates

  const onCheckChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event?.target?.checked ?? false;
    onChange({
      [name]: checked
    } as unknown as T);
  }

  return <CheckBoxInput
    name={name}
    label={label}
    value={value}
    required={required}
    disabled={disabled}
    icon={icon || undefined}
    checkedIcon={checkedIcon || undefined}
    onChange={onCheckChange}
  />
}

export { BoundCheckBoxInput };